angular.module('app.entity.audit')
    .filter('historyValue', ['$filter', 'gettextCatalog', function($filter, gettextCatalog) {
        return function(value, format, type) {
            var formattedValue;

            // GARU-3478 Comprobación por si es un metadata
            // GARU-3608 Comprobación si es archivado
            if (format === 'metadata' || format === 'store') {
                return value ? gettextCatalog.getString('Sí') : gettextCatalog.getString('No');
            }

            // GARU-3433 Hasta que se migre el audit, se traduce a mano
            if (value === 'true [Marcado]') {
                value = true;
            } else if (value === 'false [Desmarcado]') {
                value = false;
            }

            // Probamos primero según el tipo del valor
            // GARU-3472 Boolean (checkboxes solo a día de hoy) es Marcado (true) o Desmarcado (false)
            if (value === true) {
                formattedValue = gettextCatalog.getString('Marcado');
            } else if (value === false) {
                formattedValue = gettextCatalog.getString('Desmarcado');
            } else if (value && value.encrypted) {
                formattedValue = '<span class="encrypted-value">' + gettextCatalog.getString('Encriptado') + '</span>';
            } else if (type === 'datepicker' || type === 'datecomponents') {
                if (value) {
                    formattedValue = $filter('dateFormat')(value, 'dateinput');
                    if (format) {
                        formattedValue += ' [' + $filter('dateFormat')(value, format) + ']';
                    }
                } else {
                    formattedValue = '';
                }
            } else if (type === 'datetimepicker') {
                if (value) {
                    formattedValue = format.slice(-3) === ':ss'
                        ? $filter('dateFormat')(value, 'datetimeinputseconds')
                        : $filter('dateFormat')(value, 'datetimeinputminutes');

                    if (format) {
                        formattedValue += ' [' + $filter('dateFormat')(value, format) + ']';
                    }
                } else {
                    formattedValue = '';
                }
            } else if (value && value.label) {
                formattedValue = value.label;
            } else {
                switch (format) {
                    case 'yesno':
                        formattedValue = $filter('labelYesNo')(value);
                        break;
                    case 'boolean':
                        formattedValue = $filter('labelBoolean')(value);
                        break;

                    case 'html':
                    case 'string':
                    default:
                        formattedValue = value;
                }
            }

            return formattedValue;
        };
    }]);
